var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgHidden = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 25.11,
      height: 18.833,
      viewBox: "0 0 25.11 18.833",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_18197",
      "data-name": "Group 18197",
      transform: "translate(0 0)"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_17032",
      "data-name": "Group 17032",
      transform: "translate(0 0)"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_17031",
      "data-name": "Group 17031"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22200",
      "data-name": "Path 22200",
      d: "M3788.661,2587.731l-1.48-1.479-2.347,2.347a12.759,12.759,0,0,0-5.59-1.3c-5.368,0-10.044,3.372-12.555,8.37a15.965,15.965,0,0,0,5.1,5.974l-1.963,1.963,1.479,1.479,2.343-2.343,2.713-2.712h0Zm-14.648,7.943a5.231,5.231,0,0,1,5.231-5.231,5.177,5.177,0,0,1,2.877.875l-1.531,1.531a3.121,3.121,0,0,0-4.171,4.171l-1.531,1.532A5.185,5.185,0,0,1,3774.013,2595.674Z",
      transform: "translate(-3766.689 -2586.252)"
    }))),
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_17034",
      "data-name": "Group 17034",
      transform: "translate(9.11 4.768)"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_17033",
      "data-name": "Group 17033"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_22201",
      "data-name": "Path 22201",
      d: "M3927.83,2664.033l-3.933,3.934a5.085,5.085,0,0,1-5.159,5.951,5.223,5.223,0,0,1-.72-.072l-2.725,2.726a12.648,12.648,0,0,0,3.445.485c5.368,0,10.044-3.371,12.555-8.37A16.439,16.439,0,0,0,3927.83,2664.033Z",
      transform: "translate(-3915.292 -2664.033)"
    }))))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgHidden, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Hidden.e32d1b39.svg";
export { ForwardRef as ReactComponent };